import InitialInformationPage from "./InitialInformationPage";

export default InitialInformationPage;
